import { appointmentMethodMap } from 'constants/common';

export const appointmentMethodPresenter = (method: unknown) => {
  if (typeof method === 'string') {
    const presented = appointmentMethodMap[method];
    return presented;
  }
};
